import { useContext } from 'react';
import { TasklistMyTaskContext } from './TasklistMyTask';
import { RenderScreenFromTaskData } from './Screen/ScreenLoader';
import { TasklistService } from '@/api/tasklist';
import { Spinner } from 'alurkerja-ui';
import { MyTaskContextNew } from '@/pages/task/MyTask';
import HeaderTask from '@/components/tasklist/tasks/HeaderTask';
import TabGroupTask from '@/components/tasklist/tasks/TabGroupTask';
import { GroupTaskContext } from '@/pages/group-task/GroupTaskPage';
import { useKeycloak } from 'keycloak-react-web';

// Form awal
export const TaskDetail: React.FC = () => {
  /**
   * Get data and processDefinition from TasklistMyTaskContext
   * and data and processDefinition from MyTaskContextNew
   */
  const { data, processDefinition: processDefinitionKey } = useContext(TasklistMyTaskContext);
  const { data: myTaskId, processDefinition: myTaskProcessDefinition } = useContext(MyTaskContextNew);
  const { data: groupTaskId, processDefinition: groupTaskProcessDefinition } = useContext(GroupTaskContext);

  /**
   * Get task detail by task id and process definition
   * If processDefinitionKey is not provided, it will use myTaskProcessDefinition
   * If taskId is not provided, it will use myTaskId
   */
  const {
    data: taskDetail,
    isFetching,
    refetch,
  } = TasklistService.useGetTask({
    processDefinition: processDefinitionKey || myTaskProcessDefinition || groupTaskProcessDefinition,
    taskId: data || myTaskId || groupTaskId,
  });

  /**
   * Get current logged in user's username
   */
  const { keycloak } = useKeycloak();
  const loggedInUsername = keycloak.tokenParsed?.preferred_username;

  /**
   * Check if the current logged in user is allowed to edit the form
   * by comparing the username of the task with the logged in user's username
   */
  const allowedToEditForm = taskDetail?.username === loggedInUsername;

  if (isFetching) {
    return (
      <div className="flex fixed sm:relative z-50 sm:z-auto bg-white top-0 left-0 w-screen h-screen gap-4 sm:h-full sm:w-full justify-center items-center">
        <div className="flex gap-2">
          <Spinner className="text-main-blue-alurkerja" />
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 z-50 w-screen h-screen p-2 sm:z-auto sm:flex sm:relative sm:flex-col sm:w-full sm:h-auto space-y-2 bg-white overflow-y-auto">
      <HeaderTask taskDetail={taskDetail} refetch={refetch} allowedToEditForm={allowedToEditForm} />

      <div className="relative">
        <RenderScreenFromTaskData
          task={taskDetail}
          processDefinitionKey={processDefinitionKey || myTaskProcessDefinition || groupTaskProcessDefinition}
        ></RenderScreenFromTaskData>
        {!allowedToEditForm && (
          <div className="absolute bottom-0 left-0 right-0 h-full w-full bg-black-alurkerja-2 bg-opacity-5 hover:cursor-not-allowed"></div>
        )}
      </div>

      <TabGroupTask taskDetail={taskDetail} />
    </div>
  );
};
